export enum TipoMovimiento {        
    Alije,
    Devolucion,
    Pedido,
    SaldoAnterior
}